var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c(
        "div",
        { staticClass: "opt" },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "permissson",
                  rawName: "v-permissson",
                  value: "add",
                  expression: "'add'",
                },
              ],
              staticClass: "btn",
              on: { click: _vm.add },
            },
            [
              _c("svg-icon", {
                attrs: { className: "icon", iconClass: "add" },
              }),
              _vm._v("新增 "),
            ],
            1
          ),
          _c(
            "BaseFilter",
            {
              attrs: { isActive: _vm.isActive, width: 438 },
              on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
            },
            [
              _c(
                "div",
                { staticClass: "filter" },
                [
                  _c(
                    "el-form",
                    {
                      ref: "form",
                      attrs: { model: _vm.filterList, "label-width": "40px" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "类型" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "请选择类型" },
                              model: {
                                value: _vm.filterList.type,
                                callback: function ($$v) {
                                  _vm.$set(_vm.filterList, "type", $$v)
                                },
                                expression: "filterList.type",
                              },
                            },
                            _vm._l(_vm.typeOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "原币" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "请选择原币" },
                              model: {
                                value: _vm.filterList.sourceCurrency,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.filterList,
                                    "sourceCurrency",
                                    $$v
                                  )
                                },
                                expression: "filterList.sourceCurrency",
                              },
                            },
                            _vm._l(_vm.commOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "外币" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "320px" },
                              attrs: { placeholder: "请选择外币" },
                              model: {
                                value: _vm.filterList.destinationCurrency,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.filterList,
                                    "destinationCurrency",
                                    $$v
                                  )
                                },
                                expression: "filterList.destinationCurrency",
                              },
                            },
                            _vm._l(_vm.commOptions, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "type",
                      fn: function (row) {
                        return [
                          _vm._v(
                            " " + _vm._s(row.scope.type ? "应付" : "应收") + " "
                          ),
                          _c("img", {
                            staticClass: "outDate",
                            attrs: {
                              src: _vm.isOutDate(row.scope.validTo),
                              alt: "",
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permissson",
                                            rawName: "v-permissson",
                                            value: "update",
                                            expression: "'update'",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.update(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("修改")]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1536627994
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("rate-dialog", {
        attrs: { dialogVisible: _vm.dialogVisible, editData: _vm.editData },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }